<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @submitDel="del"
      @openEditFromDialog="openEditFromDialog"
    >
      <div slot="header">
        <b-button
          class="mr-2"
          size="sm"
          :disabled="disabled"
          variant="outline-success"
          @click="() => (uploadFormDialogVisible = true)"
        >
          <i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
        </b-button>
      </div>
    </Main>

    <UploadFormDialog
      :title="$l('INDEX.dialog_order_accessories_doc_upload') || '上传订单辅料文件'"
      :visible.sync="uploadFormDialogVisible"
      :changeOrderCode="changeOrderCode"
      @confirm="orderBatchConfirm"
    />

    <EditFromDialog
      :title="$l('INDEX.dialog_order_accessories_doc_edit') || '编辑订单辅料文件'"
      :visible.sync="editFromDialogOption.visible"
      :data="editFromDialogOption.data"
      :changeOrderCode="changeOrderCode"
      @confirm="save"
    />
  </div>
</template>
<script>
import Main from './main'
import UploadFormDialog from '../upload-form/dialog.vue'
import EditFromDialog from '../edit-form/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, UploadFormDialog, EditFromDialog },
  props: {
    materialDocList: {
      type: Array,
      default: () => [],
    },
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  watch: {
    materialDocList: {
      handler(val) {
        this.tableData = val
      },
      immediate: true,
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      uploadFormDialogVisible: false,
      editFromDialogOption: {
        visible: false,
        data: {},
      },
    }
  },
  methods: {
    orderBatchConfirm(data) {
      this.addTableData(data)
    },
    addTableData(data) {
      this.tableData.push(...data)
    },

    del(delRows) {
      if (delRows[0].uuid) {
        const tableData = this.tableData.filter(
          (i) => delRows.findIndex((j) => i.uuid == j.uuid) < 0
        )
        this.tableData = [...tableData]
      } else {
        const tableData = this.tableData.filter(
          (i) =>
            delRows.findIndex(
              (j) => i.orderMaterialDocCode == j.orderMaterialDocCode
            ) < 0
        )
        this.tableData = [...tableData]
      }
    },
    getTableData() {
      return this.tableData
    },
    openEditFromDialog(data) {
      if (!data.uuid) {
        data.uuid = this.getUUID()
      }
      this.editFromDialogOption = {
        visible: true,
        data: data,
      }
    },
    save(res) {
      if (!res) return
      for (let index = 0; index < this.tableData.length; index++) {
        if (res.uuid === this.tableData[index].uuid) {
          this.$set(this.tableData, index, res)
          return
        }
      }
      this.tableData.push(res)
    },
    getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
  },
}
</script>
